import { apiRequest } from "../util/apiUtils";

export const postList = async (params) => {
  try {
    const res = await apiRequest("get", `post/backend/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

// for user Job list
export const jobUserList = async (params) => {
  try {
    const res = await apiRequest("get", `post/job/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `post/backend/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `post/backend/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `post/backend/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `post/backend/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const postDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `/post/backend/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const jobDetailsUser = async (payload) => {
  try {
    const res = await apiRequest("get", `/post/job/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};